module.exports = __webpack_public_path__ + "static/img/24.5f40d57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/24.jpg
// module id = bGeR
// module chunks = 1